import React, { useRef, useState, useEffect } from "react";
import { Play, Pause } from "lucide-react";

export default function VoiceMessage({ src, isSelf }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState("0:00");
  const [current, setCurrent] = useState("0:00");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleLoaded = () => setDuration(formatTime(audio.duration));
    const handleTimeUpdate = () => {
      setCurrent(formatTime(audio.currentTime));
      setProgress((audio.currentTime / audio.duration) * 100);
    };

    audio.addEventListener("loadedmetadata", handleLoaded);
    audio.addEventListener("timeupdate", handleTimeUpdate);
    audio.addEventListener("ended", () => setIsPlaying(false));

    return () => {
      audio.removeEventListener("loadedmetadata", handleLoaded);
      audio.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, []);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const m = Math.floor(time / 60);
    const s = Math.floor(time % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={togglePlay}
        className={`w-8 h-8 flex items-center justify-center rounded-full ${
          isSelf ? "bg-white/30" : "bg-purple-200"
        }`}
      >
        {isPlaying ? (
          <Pause size={16} className={isSelf ? "text-white" : "text-purple-700"} />
        ) : (
          <Play size={16} className={isSelf ? "text-white" : "text-purple-700"} />
        )}
      </button>

      <div className="flex-1 h-[3px] bg-gray-300 rounded-full relative overflow-hidden">
        <div
          className={`absolute top-0 left-0 h-full ${
            isSelf ? "bg-white" : "bg-purple-600"
          } transition-all duration-200`}
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <span className="text-xs opacity-80">{current}</span>
      <audio ref={audioRef} src={src} preload="metadata" />
    </div>
  );
}
